import React, { useState, useEffect } from "react";
import "./../UserManagementPage/AddUserModal.css"; // Reuse styles
import { useAuth } from "../../../context/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const IpWhitelistModal = ({ isOpen, onClose, onSave, ipData }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({ ip: "", note: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const isEditMode = !!ipData;

  useEffect(() => {
    if (isEditMode && ipData) {
      setFormData({ ip: ipData.ip, note: ipData.note });
    } else {
      setFormData({ ip: "", note: "" });
    }
  }, [ipData, isEditMode, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.ip.trim()) {
      newErrors.ip = "Địa chỉ IP không được để trống.";
    } else if (!/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(formData.ip)) {
      newErrors.ip = "Địa chỉ IP không hợp lệ.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      ...formData,
      ...(isEditMode ? { updatedBy: user.name } : { createdBy: user.name }),
    };

    try {
      await onSave(payload, ipData?._id);
      MySwal.fire({
        icon: "success",
        title: "Thành công!",
        text: `Đã ${isEditMode ? "cập nhật" : "thêm"} IP thành công.`,
        timer: 1500,
        showConfirmButton: false,
      });
      handleClose();
    } catch (err) {
      MySwal.fire({
        icon: "error",
        title: "Thao tác thất bại",
        text: err.response?.data?.message || "Có lỗi xảy ra.",
      });
      console.error("Save IP error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ ip: "", note: "" });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isEditMode ? "Chỉnh sửa IP Whitelist" : "Thêm IP Whitelist"}</h2>
          <button className="close-button" onClick={handleClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="ip">Địa chỉ IP *</label>
            <input
              type="text"
              id="ip"
              name="ip"
              value={formData.ip}
              onChange={(e) => setFormData({ ...formData, ip: e.target.value })}
              className={errors.ip ? "error" : ""}
              placeholder="Ví dụ: 192.168.1.1"
              disabled={loading}
            />
            {errors.ip && <span className="error-message">{errors.ip}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="note">Ghi chú</label>
            <textarea
              id="note"
              name="note"
              rows="3"
              value={formData.note}
              onChange={(e) =>
                setFormData({ ...formData, note: e.target.value })
              }
              placeholder="Thêm mô tả cho IP (ví dụ: IP văn phòng)"
              disabled={loading}
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={handleClose}
              disabled={loading}
            >
              Hủy
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Đang lưu..." : "Lưu"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IpWhitelistModal;
